import {
  componentNameValidationMixin,
  createProxy,
  createStyleMixin,
  draggableMixin,
} from '@descope-ui/common/components-mixins';
import { getComponentName } from '@descope-ui/common/components-helpers';
import { ImageClass } from '@descope-ui/descope-image/class';
import { compose } from '@descope-ui/common/utils';

export const componentName = getComponentName('icon');

export const IconClass = compose(
  createStyleMixin({
    mappings: {
      fill: [{}, { property: ImageClass.cssVarList.fill }],
    },
  }),
  draggableMixin,
  componentNameValidationMixin,
)(
  createProxy({
    slots: [],
    wrappedEleName: 'descope-image',
    style: () => `
      :host {
        display: inline-flex;
        max-height: 100%;
      }
      `,
    excludeAttrsSync: ['tabindex', 'class', 'style'],
    componentName,
  }),
);
